// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import InnovationContent from './PageComponent/InnovationContent';


function Innovation() {

    useMeta({
        title: 'Innovation | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/innovation/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Innovation | Callistus Blinds',
            description:
                'Callistus’ Passion is Innovation. We believe that innovation in blinds brings a new dimension and pleasure in the living space which enhances happiness in life by offering Light Control according to the need, mood, and Privacy. We have the World’s largest range of 15 Types of Blinds, 10 Operating Systems, and 2000+ shade options to match and beautify the interior.',
            url: 'https://callistusblinds.com/innovation/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <InnovationContent />
            <Footer />
        </div>
    );
}

export default Innovation;
